import { ASSISTANT_LABEL } from '../helpers/chatMessage';
import {
  Bubble,
  BubbleColumn,
  BubbleLine,
  MessageMeta,
  MessageRow,
} from './MessageBubble.styled';
import { ThinkingIndicator } from './ThinkingIndicator';

/**
 * The support bot's turn, standing where its answer will land.
 *
 * Built out of the message parts rather than beside them, because that is the
 * whole idea: it is the incoming white card with the assistant's name under
 * it, holding the shared thinking line instead of a body, and the bot's real
 * message takes its place the moment it arrives. Viktor already worked this
 * way - his dots are the bubble he then writes into - and a merchant waiting
 * on the bot now sees the same thing rather than a note above the composer.
 *
 * Not a message: it has no id, no clock and nothing to reply to, so it stays
 * out of `MessageList` and out of the cache. `useConversationsSocket` decides
 * when it shows - after 400ms, since two merchant messages in five are
 * answered by a rule in milliseconds and a flash of this would be worse than
 * nothing - and takes it away on `done`, on the bot's own message, or after
 * 60s of silence.
 */
export const AssistantThinkingBubble = ({ label }: { label: string }) => (
  <MessageRow $own={false}>
    <BubbleColumn $own={false}>
      <BubbleLine>
        <Bubble $own={false}>
          <ThinkingIndicator label={label} tone="card" />
        </Bubble>
      </BubbleLine>
      {/* The same name the answer will carry, so nothing is renamed under the
          reader when the message lands. */}
      <MessageMeta $own={false}>{ASSISTANT_LABEL}</MessageMeta>
    </BubbleColumn>
  </MessageRow>
);
